import React from 'react';
import { TCN } from './tokens';

/**
 * TCN SectionLabel — uppercase tracked label, often with a trailing action link.
 *
 * Props:
 *  - children: text
 *  - action: optional { label, onClick } or ReactNode
 */
const SectionLabel = ({ children, action, className = '', style }) => {
  return (
    <div
      className={`flex items-center justify-between ${className}`}
      style={{
        marginBottom: 8,
        ...style,
      }}
    >
      <div
        style={{
          fontSize: 11,
          fontWeight: 700,
          color: TCN.textDim,
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          fontFamily: TCN.fontSans,
        }}
      >
        {children}
      </div>
      {action && (
        typeof action === 'object' && action.label
          ? (
            <button
              type="button"
              onClick={action.onClick}
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: TCN.cyan,
                letterSpacing: '0.04em',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                padding: 0,
              }}
            >
              {action.label}
            </button>
          )
          : action
      )}
    </div>
  );
};

export default SectionLabel;
